import { CoinIcon } from '@/components/ui/CoinIcon';
import i18n from '@/i18n';
import { Icon } from '@/components/ui/Icon';
import { cx } from '@/lib/format';
import type { Notice } from '@/types';

const KIND_ICON: Record<Notice['kind'], string> = { price: 'price', whale: 'whale', digest: 'ws', calendar: 'cal', news: 'news', x: 'x', payment: 'card', forecast: 'ai' };
/** the kind's label in the current language */
const KINDS = ['price', 'whale', 'digest', 'calendar', 'news', 'x', 'payment', 'forecast'];
export const KIND_LABEL = new Proxy({} as Record<Notice['kind'], string>, { get: (_, k) => (typeof k === 'string' && KINDS.includes(k) ? i18n.t(`notices:kind.${k}`) : undefined) });

/** Coin mark with a direction badge for price alerts, line icon otherwise. */
export function NoticeIcon({ n }: { n: Notice }) {
  if (n.kind === 'price' && n.symbol) {
    return <span className={cx('nic coin', n.dir)}><CoinIcon symbol={n.symbol} /><i aria-hidden="true">{n.dir === 'down' ? '↓' : '↑'}</i></span>;
  }
  return <span className={cx('nic', n.kind)}><Icon name={KIND_ICON[n.kind]} /></span>;
}
